import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { useWatchInput } from "../../hooks/useWatchInput";
import AppointmentRequestForm from "./appointment_request_form";

const AppointmentRequestToDoListForm = ({
  appointment_state_request_state,
  to_do_list_state,
  initialState,
  show
}) => {
  const [showOptionForAppointmentRequest, setShowOptionForAppointmentRequest] = useState(false);
  const [showAppointmentRequestForm, setShowAppointmentRequestForm] = useState(false);

  useEffect(() => {
    updateInitialState();
  }, [to_do_list_state, appointment_state_request_state]);

  const watchedTaskTypeChange = useWatchInput({ id: "task-type-select" });
  useEffect(() => {
    if (
      watchedTaskTypeChange == "Appointment" ||
      watchedTaskTypeChange == "Appointment (All locations)"
    ) {
      setShowOptionForAppointmentRequest(true);
    }
  }, [watchedTaskTypeChange]);

  const updateInitialState = () => {
    if (!to_do_list_state) return;
    if (
      to_do_list_state.task_type !== "Appointment" &&
      to_do_list_state.task_type !== "Appointment (All locations)"
    )
      return;
    setShowOptionForAppointmentRequest(true);
    if (!appointment_state_request_state) return;
    setShowAppointmentRequestForm(true);
  };
  // TODO add duration
  // TODO disable date if it's requiring appointment (but tell them they can edit them once it's made or maybe have way to edit first edition)
  // TODO autofill location
  // TODO have default date autofill
  if (!showOptionForAppointmentRequest && !show) return <></>;

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={showAppointmentRequestForm}
            onChange={() => setShowAppointmentRequestForm(!showAppointmentRequestForm)}
          />
        }
        label="Peer support worker required"
      />
      {showAppointmentRequestForm && (
        <div className="ccw-peer-support-form">
          <AppointmentRequestForm
            showTitle={true}
            appointment_state_request_state={appointment_state_request_state}
            to_do_list_state={to_do_list_state}
            initialState={initialState}
          />
        </div>
      )}
    </div>
  );
};

AppointmentRequestToDoListForm.propTypes = {
  appointment_state_request_state: PropTypes.object,
  to_do_list_state: PropTypes.object,
  initialState: PropTypes.object,
  show: PropTypes.bool
};

export default AppointmentRequestToDoListForm;
